var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        title: _vm.$t("DELETE_BULK_TAGS_CONFIRMATION_TITLE"),
        entity: _vm.bulkTags,
        "show-confirm-button": true,
        "show-cancel-button": true,
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("DELETE"),
        "confirm-button-disabled": _vm.disableModalConfirm,
        "confirm-button-loading": _vm.deletingBulkTags
      },
      on: { close: _vm.closeModal, confirm: _vm.deleteBulkTags }
    },
    [
      _vm.getBulkTagsReferencesStatus.status == "pending"
        ? _c(
            "div",
            [
              _c("Loader", { attrs: { "custom-class": "size-sm" } }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("DELETE_BULK_TAGS_MODAL_CHECK_ASSOCIATION_TEXT", {
                      bulkTagsToDeleteName: _vm.bulkTagsToDeleteName
                    })
                  )
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getBulkTagsReferencesStatus.status == "success"
        ? _c("div", [
            !_vm.hasReferences
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("DELETE_BULK_TAGS_MODAL_TEXT", {
                        bulkTagsToDeleteName: _vm.bulkTagsToDeleteName
                      })
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasReferences
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("DELETE_BULK_TAGS_MODAL_NONE_ASSOCIATION_TEXT", {
                        bulkTagsToDeleteName: _vm.bulkTagsToDeleteName
                      })
                    )
                  }
                })
              : _c("div", [
                  _c("p", {
                    staticClass: "m-b-10",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("DELETE_BULK_TAGS_MODAL_ASSOCIATION_TEXT", {
                          bulkTagsToDeleteName: _vm.bulkTagsToDeleteName
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "well well-sm m-b-10" }, [
                    _c(
                      "div",
                      { staticClass: "form-horizontal" },
                      _vm._l(_vm.groupedReferences, function(value, type) {
                        return _c("div", { staticClass: "row" }, [
                          _c(
                            "label",
                            { staticClass: "col-md-3 control-label" },
                            [_c("strong", [_vm._v(_vm._s(type + "s"))])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-8" }, [
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "list-unstyled form-control-static list-text-overflow"
                              },
                              _vm._l(value, function(item, index) {
                                return _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: item.link,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "display-text",
                                          attrs: { title: item.name }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(item.name) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "fa fa-external-link m-l-5",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  )
                                ])
                              }),
                              0
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-horizontal m-l-10 m-r-10" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "DELETE_BULK_TAGS_ATTEST_PRE",
                            expression: "'DELETE_BULK_TAGS_ATTEST_PRE'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "m-t-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.forceDelete,
                              expression: "forceDelete"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.forceDelete)
                              ? _vm._i(_vm.forceDelete, null) > -1
                              : _vm.forceDelete
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.forceDelete,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.forceDelete = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.forceDelete = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.forceDelete = $$c
                                }
                              },
                              _vm.attestDelete
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "DELETE_BULK_TAGS_ATTEST",
                              expression: "'DELETE_BULK_TAGS_ATTEST'"
                            }
                          ]
                        })
                      ])
                    ])
                  ])
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.getBulkTagsReferencesStatus.status == "error"
        ? _c("div", [
            _c("div", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DELETE_BULK_TAGS_MODAL_CHECK_ASSOCIATION_ERROR_TEXT",
                  expression:
                    "'DELETE_BULK_TAGS_MODAL_CHECK_ASSOCIATION_ERROR_TEXT'"
                }
              ],
              staticClass: "bs-callout bs-callout-danger"
            })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }